// Splide
import slideShow from '../../slideShow'

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-slideshow').forEach(slide => {
        slideShow(slide)
    })
})
